// import 'alpinejs';

import { tns } from 'tiny-slider/src/tiny-slider';

import '@fancyapps/fancybox';

/**
 * Next - custom JS for this theme
 */

$(function() {

    if ($('[data-fancybox="gallery"]').length > 0) {
        $('[data-fancybox="gallery"]').fancybox({
            loop: true,
        });
    }

    // init the tns slider if exists
    if ($('#tns-slider').length > 0) {
        var slider = tns({
            container: '#tns-slider',
            items: 1,
            slideBy: 'page',
            autoplay: false,
            "navContainer": ".slider-dots",
            controls: false,
        });
    }

    // init the tns slider if exists
    if ($('#testimonials-carousel').length > 0) {
        var slider = tns({
            container: '#testimonials-carousel',
            mode: 'gallery',
            items: 1,
            slideBy: 'page',
            nav: false,
            "controlsContainer": ".carousel-controls",
        });
    }

});
